import { REHYDRATE } from "redux-persist/constants"

import {
    AUTHENTICATION_LOGIN_RESPONSE,
    UNAUTHENTICATED
} from "../actions/action-types"
import ROUTES from "../config/routes"

export default (state = [], action) => {
    const { type, permissions } = action
    switch (type) {
        case REHYDRATE:
            const authentication = action.payload.authentication
            if (authentication && authentication.permissions)
                return getAvailableRoutes(ROUTES, authentication.permissions)
            else return state
        case AUTHENTICATION_LOGIN_RESPONSE:
            return getAvailableRoutes(ROUTES, permissions)
        case UNAUTHENTICATED:
            return []
        default:
            return state
    }
}

function getAvailableRoutes(allRoutes, permissions) {
    return allRoutes
        .reduce(
            (routesList, route) => routesList.concat(route.switch || [route]),
            []
        )
        .filter(
            route =>
                // Filter out routes that are not for display
                route.label &&
                // and where some permissions that are required are missing from the user's permissions
                !route.permissionsRequired.some(
                    permissionRequired =>
                        permissions.indexOf(permissionRequired) === -1
                )
        )
}
